import { useTranslation } from "react-i18next";
import { coerceLocale, type Locale } from "@heraion/shared";

// The reader's language, as a supported `Locale`.
//
// Built while wiring PE-21 (program translations), which needed the
// reader's language in four more places: the same
// `coerceLocale(i18n.resolvedLanguage ?? i18n.language)` line was
// already copy-pasted around the package, twice under the name
// `normaliseLocale` with its own 5-locale list. One primitive per
// concept — the resolution order (resolvedLanguage before language)
// matters and should only be decided once.
export const useLocale = (): Locale => {
  const { i18n } = useTranslation();
  return coerceLocale(i18n.resolvedLanguage ?? i18n.language);
};
